
import React, { useState } from "react";
import TransactionDetailsAPI from "../../../api/TransactionDetailsAPI";
import RepeatTransaction from "../RepeatTransaction";
import BlurLoading from "../BlurLoading";
import "../../../utils/Style/component/repeat-button.scss";


export default function RepeatButton({
  transactionId,
  disabled,
  onOpenQrAfterGenerate,
}) {
  const { GetTransactionDetails } = TransactionDetailsAPI();

  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [transactionID, setTransactionID] = useState(null);

  const handleRepeatTransaction = async () => {
    if (disabled || loading) return;

    setLoading(true);

    try {
      await GetTransactionDetails(transactionId);
      setTransactionID(transactionId);
      setModalOpen(true);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      

      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          handleRepeatTransaction();
        }}
        className="repeat_transaction_button"
        disabled={disabled || loading}
      >
        <img src="Images/LoadRepeatLogo.png" />
        Repeat
      </button>

      {modalOpen && (
        <RepeatTransaction
          transactionID={transactionID}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          onOpenQrAfterGenerate={onOpenQrAfterGenerate}
        />
      )}
      <BlurLoading show={loading} />
    </>
  );
}

